module.exports = __webpack_public_path__ + "img/0706-二层建筑-06.836f68c5.png";